module.exports = __webpack_public_path__ + "img/car-buyers-guide-deal.2515e52c.jpg";